import { addError } from 'action-creators/ErrorActionCreators';
import { connect } from 'react-redux';

import StateWrappedAttachments from 'components/attachments/components/StateWrappedAttachments';

const mapStateToProps = (state, ownProps) => {
  const attachmentIds =
    state.ui.ordering[`methodStepAttachments--${ownProps.attachableId}`]
      ?.list || [];
  const existingAttachments = attachmentIds.map(
    (attachmentId) => state.domain.attachmentCollection.data[attachmentId],
  );
  const includedCoverImages = state.domain.coverImageCollection.allDataIds.map(
    (coverImageId) => state.domain.coverImageCollection.data[coverImageId],
  );
  const includedAttachments = state.domain.attachmentCollection.allDataIds.map(
    (attachmentId) => state.domain.attachmentCollection.data[attachmentId],
  );

  const attachmentKeys =
    state.ui.adding[`methodStepAttachmentKeys--${ownProps.attachableId}`] || [];
  const newAttachments = attachmentKeys.map(
    (attachmentKey) => state.application.newAttachments[attachmentKey],
  );

  return {
    seedAttachments: {
      data: [...existingAttachments, ...newAttachments],
      included: [...includedCoverImages, ...includedAttachments],
    },
  };
};

const mapDispatchToProps = (dispatch, _ownProps) => ({
  dispatch,
  addError: (errorKey, payload) => dispatch(addError(errorKey, payload)),
});

const mergeProps = (stateProps, dispatchProps, ownProps) => ({
  ...stateProps,
  ...dispatchProps,
  ...ownProps,
  modalContainerSelector: '#modalRoot',
});

const AvailableAttachments = connect(
  mapStateToProps,
  mapDispatchToProps,
  mergeProps,
)(StateWrappedAttachments);

export default AvailableAttachments;
